module.exports = "/images/vendor/flag-icon-css/flags/4x3/gy.svg?79fcf270400edca30d7790872057d26c";